export default __webpack_public_path__ + "static/media/background.f6814621.webp";